import React from "react";
import { ReactFlowProvider } from "@xyflow/react";
import { FormattedMessage } from "react-intl";
import { objectPathsShape } from "../../shapes/objectPathShape";
import Icon from "../Icon";
import Topology from "./Topology";

type Props = {
  paths: objectPathsShape;
};

function ObjectPathTopology({ paths }: Props) {
  const [isViewOpen, setIsViewOpen] = React.useState(false);

  React.useEffect(() => {
    if (isViewOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isViewOpen]);

  return (
    <div className="topology-container">
      <button
        type="button"
        disabled={paths?.length === 0}
        onClick={() => setIsViewOpen(true)}
        className="btn-link open-topology"
      >
        <Icon name="icon3-eh-network" />
        <span>
          <FormattedMessage id="button.topology_view" />
        </span>
      </button>
      {paths?.length > 0 && isViewOpen && (
        <ReactFlowProvider>
          <Topology
            // @ts-expect-error TS(2322) FIXME: Type '{ isOpen: true; paths: objectPathsShape; onC... Remove this comment to see the full error message
            isOpen={isViewOpen}
            paths={paths}
            onClose={() => setIsViewOpen(false)}
          />
        </ReactFlowProvider>
      )}
    </div>
  );
}

export default ObjectPathTopology;
